import React, { useState } from 'react'
// PlaneIco is only used inside the commented-out PromoBanner below.
import { Bottles, Charger, MyLocation, StarWhite } from '../../../assests/ExportImageIcon'
import SeatBookingPanel from './busSeatTab/SeatBookingPanel'
import './busResults.css'

// This page is a static placeholder — no bus search API exists yet, so every result
// below is hardcoded to match the reference design exactly (no state, no per-result
// click behaviour). "VIEW SEATS" expands the static seat-selection panel inline
// under the card (like flight's "FLIGHT DETAILS" toggle) — there's no real
// per-bus seat layout yet. Once a bus API is available, this can be wired up
// the same way flight/FlightResults.jsx is.

export const BUS_RESULT = {
    operator: 'VRL Travels',
    busType: 'AC Semi-Sleeper 2+1',
    departureTime: '02:50 PM',
    duration: '14h 30m',
    arrivalTime: '02:50 AM',
    price: '₹3,453',
    rating: '4.5',
    reviews: '1,234',
    seatsLeft: 12,
    windows: 4,
    onTime: true,
}

const BUS_RESULTS = Array.from({ length: 8 }, () => BUS_RESULT)

export const BusResultCard = ({ item }) => {
    const [seatsOpen, setSeatsOpen] = useState(false)

    return (
    <div className='resultCard hoverLift'>
        <div className='resultCard__main'>
            <div className='resultCard__airline'>
                <div>
                    <div className='resultCard__airlineName'>{item.operator}</div>
                    <div className='resultCard__flightNo'>{item.busType}</div>
                </div>
            </div>
            <div className='resultCard__time'>
                <div className='resultCard__timeValue'>{item.departureTime}</div>
            </div>
            <div className='resultCard__duration'>
                <div className='resultCard__durationValue'>{item.duration}</div>
                <div className='busResultCard__seatsInfo'>{item.seatsLeft} Seats Left • {item.windows} Windows</div>
            </div>
            <div className='resultCard__time'>
                <div className='resultCard__timeValue'>{item.arrivalTime}</div>
            </div>
            <div className='resultCard__price'>
                <div className='resultCard__priceValue'>{item.price}</div>
            </div>
        </div>

        <div className='busResultCard__metaRow'>
            <div className='busResultCard__rating'>
                <span className='hotelCard__ratingBadge'>
                    <img src={StarWhite} alt="" /> {item.rating}
                </span>
                <span className='busResultCard__reviews'>({item.reviews})</span>
            </div>
            <div className='busResultCard__amenities'>
                <img src={Charger} alt="" />
                <img src={MyLocation} alt="" />
                <img src={Bottles} alt="" />
            </div>
        </div>

        <div className='resultCard__footer'>
            <div className={`resultCard__refundTag ${item.onTime ? 'resultCard__refundTag--yes' : 'resultCard__refundTag--no'}`}>
                {item.onTime ? 'On Time' : 'Delayed'}
            </div>
            <button type="button" className='resultCard__details commonGredientText' onClick={() => setSeatsOpen(!seatsOpen)}>
                VIEW SEATS <span>&#8250;</span>
            </button>
        </div>

        {seatsOpen && <SeatBookingPanel />}
    </div>
    )
}

// const PromoBanner = () => (
//     <div className='busPromoBanner'>
//         <span className='busPromoBanner__ring busPromoBanner__ring--1' />
//         <span className='busPromoBanner__ring busPromoBanner__ring--2' />
//         <img src={PlaneIco} alt="" className='busPromoBanner__plane' />
//         <div className='busPromoBanner__text'>
//             Unlock exclusive 12% Off on your first booking.
//             <div className='busPromoBanner__code'>Code: NEW</div>
//         </div>
//         <button type='button' className='busPromoBanner__loginBtn'>Log in</button>
//     </div>
// )

const BusResults = () => {
    return (
        <div className='flightResults'>
            {BUS_RESULTS.map((item, index) => (
                <React.Fragment key={index}>
                    <BusResultCard item={item} />
                    {index === 5}
                </React.Fragment>
            ))}
        </div>
    )
}

export default BusResults
